import fetch from "@/utils/fetch";

/* 获取省局列表 */

export function getProviceList(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getProvinceList',
    url: "eavar/bureau/list",
    method: "post",
    data: params,
  });
}

// zym.新闻出版署：获取出版社列表
export function getWaitList(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getPublishList',
    url: "eavar/examine/list",
    method: "post",
    data: params,
  });
}

/* 获取连续型出版物列表 */

export function getSuccessiveList(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getLxdzPublishList',
    url: "eavar/lxdz/examine/list",
    method: "post",
    data: params,
  });
}

// zym.总局核验
export function adminExam(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/executeBatch',
    url: "eavar/general/examine/executeBatch",
    method: "post",
    data: params,
  });
}

// zym.总局整体发布
export function postToPvs(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/wholeRelease',
    url: "eavar/general/examine/wholeRelease",
    method: "post",
    data: params,
  });
}

// zym.总局整体退回
export function backToPvs(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/wholeBack',
    url: "eavar/general/examine/wholeBack",
    method: "post",
    data: params,
  });
}

// zym.总局整体退回
export function batchBackSystem(params) {
  return fetch({
    // url: 'Ydnj/Ydnj/wholeBack',
    url: "eavar/general/examine/batchBackSystem",
    method: "post",
    data: params,
  });
}

// zym.音像、电子申报情况统计
export function listAdminAuditQuery(params) {
  return fetch({
    url: "eavar/general/examine/listAdminAuditQuery",
    method: "post",
    data: params,
  });
}

export function getWorkerStatisticList(params) {
  return fetch({
    url: "eavar/ydnj/getWorkerStatisticList",
    method: "post",
    data: params,
  });
}

export function getBasicInfoStatisticList(params) {
  return fetch({
    url: "eavar/ydnj/getBasicInfoStatisticList",
    method: "post",
    data: params,
  });
}

export function getPublicationStatisticList(params) {
  return fetch({
    url: "eavar/ydnj/getPublicationStatisticList",
    method: "post",
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/adminRole/adminRole.js